
export const GET_CONFIG_FORM = 'get_config_form';
export const GET_TAREAS = 'get_tareas';
export const GET_ESTADOS_CASO = 'get_estados_caso';
export const GET_TIPO_GESTION = 'get_tipo_gestion';
export const GET_INSTANCIA_JUDICIAL = 'get_instancia_judicial';
export const GET_CRITERIOS_FECHA = 'get_criterios_fecha';
export const GET_TAREAS_USUARIO = 'get_tareas_usuario';
export const GET_CASOS_BANDEJA = 'get_casos_bandeja';
export const GET_RANGO_FECHAS = 'get_rango_fechas';
export const GET_XLS_CASOS_BANDEJA = 'get_xls_casos_bandeja';
export const CLEAR_CASOS_BANDEJA = 'clear_casos_bandeja';
export const GET_FILTROS = 'get_filtros';
export const GET_COMPANIAS = 'get_companias';

export const GET_COMBO_COMPETENCIA = 'get_combo_competencia';
export const GET_COMBO_REGION_CORTE = 'get_combo_region_corte';
export const GET_COMBO_JUZGADO_TRIBUNAL = 'get_combo_juzgado_tribunal';

export const GET_SIT_PENDIENTE = 'get_combo_situacion_pendiente';